/** --------------------------------------------------
*
*   paragraphs
*   PARAGRAPH: PHOTO GALLERY
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.paragraph_content_image = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      if (!once('paragraph_content_image', 'html').length) {
        return;
      }
      self.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      const imageParagraphs = document.querySelectorAll('.js-p-image[data-lightbox="true"]');
      imageParagraphs.forEach(function(element) {
        const imageParagraph = element;

        // setup lightbox galleries:
        self._setupLightbox(imageParagraph);
      });
    },

    _setupLightbox: function(imageParagraph) {

      // prepare lightbox galleries:
      // - generate a unique "data-fancybox" attribute value per paragraph
      // - update the fancybox options per paragraph

      // unique id for this paragraph:
      const paragraphId = 'p-contentimage-' + duo.Utils.uniqueId;

      // make all fancybox links within the paragraph visible and add a unique id:
      const lightboxLinks = imageParagraph.querySelectorAll('[data-lightbox]');
      lightboxLinks.forEach(function(element) {
        const lightboxLink = element;
        lightboxLink.removeAttribute('hidden');
        lightboxLink.setAttribute('data-fancybox', paragraphId);
      });
      
      // update fancybox options:
      const fancyBoxSelector = `.js-p-image [data-fancybox="${ paragraphId }"]`;
      Fancybox.bind(fancyBoxSelector, {
        animated: false,
        closeButton: 'outside',
        dragToClose: false,
        infinite: false,
        showClass: false,

        Thumbs: true,

        Image: {
          zoom: false,
          wheel: false,
          click: false,
        },

        Toolbar: {
          display: ["close"],
        },

        l10n: {
          CLOSE: Drupal.t('Close'),
          NEXT: Drupal.t('Next'),
          PREV: Drupal.t('Previous'),
          MODAL: Drupal.t('You can close this modal with the ESC key'),
          ERROR: Drupal.t('Something went wrong, please try again'),
          IMAGE_ERROR: Drupal.t('Image not found'),
          ELEMENT_NOT_FOUND: Drupal.t('HTML element not found'),
          AJAX_NOT_FOUND: Drupal.t('Error loading AJAX: not found'),
          AJAX_FORBIDDEN: Drupal.t('Error loading AJAX: forbidden'),
          IFRAME_ERROR: Drupal.t('Error loading page')
        }
      });
    }
  };
})(Drupal, once, window.duo = window.duo || {});
